import {REPRESENTATION} from './representation.model';

/**
 * Formes sous lesquelles un effort peut se présenter, dans l'ordre où le paramétrage les propose.
 *
 * Les icônes n'en sont pas : ni l'étoile ni le smiley ne diraient la peine que le répondant a dû se
 * donner — on compte les unes, on lit les autres, mais aucune ne se gradue en effort.
 */
export const CES_REPRESENTATIONS: REPRESENTATION[] = [REPRESENTATION.NUMBER, REPRESENTATION.TEXT];
